import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

const SIZE_CLASSES = {
  s: "max-w-lg",      // ~512px
  m: "max-w-3xl",     // ~768px
  l: "max-w-5xl",    // ~1024px
  xl: "max-w-full",    // ~1024px
};

function FormModal({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  size = "xl",
  showCloseButton = true,
  closeButtonText = "Close"
}) {
  const maxWidthClass = SIZE_CLASSES[size] || SIZE_CLASSES.xl;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="relative z-50"
    >
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />

      {/* Centered content */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          className={`mx-auto w-full ${maxWidthClass} rounded-xl bg-white p-6 shadow-xl`}
        >
          {/* Header */}
          <div className="flex items-center justify-between mb-4">
            <Dialog.Title className="text-xl font-bold text-gray-900">
              {title}
            </Dialog.Title>
            <button
              type="button"
              className="text-gray-400 hover:text-gray-500"
              onClick={onClose}
            >
              <span className="sr-only">Close</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>

          {/* Scrollable content area */}
          <div className="max-h-[70vh] overflow-y-auto pr-2">
            {children}
          </div>

          {/* Footer */}
          {showCloseButton && (
            <div className="mt-6 flex justify-end border-t pt-4">
              <button
                type="button"
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
                onClick={onClose}
              >
                {closeButtonText}
              </button>
            </div>
          )}
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}

export default FormModal;